module.exports = "<div>\n    <span>{{::data.unicode}}</span>\n    <span>{{::data.shortname}}</span>\n</div>\n";